// Fotos dos comprovantes na tela: tirar ou escolher, miniaturas e ver grande.
// A foto é reduzida no próprio celular antes de guardar (sobe rápido mesmo
// com sinal fraco).
import { anexos } from '../dados.js';
import { h, icone } from '../lib/dom.js';
import { mensagemDeErro } from '../lib/erros.js';
import { prepararArquivo } from '../lib/fotos.js';
import { avisar, dialogo } from './componentes.js';

// Botões "Tirar foto" (abre a câmera no celular) e "Escolher arquivo" (foto
// da galeria ou PDF). `aoEscolher(preparados)` recebe as fotos já reduzidas.
export function botoesDeFoto(aoEscolher, { desativado = false } = {}) {
  const entrada = (props) => h('input', { type: 'file', hidden: true, tabindex: '-1', ...props });
  const camera = entrada({ accept: 'image/*', capture: 'environment', 'aria-label': 'Tirar foto do comprovante' });
  const arquivo = entrada({ accept: 'image/*,application/pdf', multiple: true, 'aria-label': 'Escolher foto ou PDF do comprovante' });
  let ocupado = false;
  const receber = async (input) => {
    const lista = [...input.files];
    input.value = '';
    if (lista.length === 0 || ocupado) return;
    ocupado = true;
    const preparados = [];
    try {
      for (const f of lista) {
        try {
          preparados.push(await prepararArquivo(f));
        } catch (erro) {
          avisar(mensagemDeErro(erro), 'erro');
        }
      }
      if (preparados.length > 0) await aoEscolher(preparados);
    } catch (erro) {
      avisar(mensagemDeErro(erro), 'erro');
    } finally {
      ocupado = false;
    }
  };
  camera.addEventListener('change', () => receber(camera));
  arquivo.addEventListener('change', () => receber(arquivo));
  return h('div', { class: 'acoes-lado botoes-foto' },
    camera,
    arquivo,
    h('button', { class: 'botao secundario', type: 'button', disabled: desativado, onClick: () => camera.click() }, icone('camera', { tamanho: 20 }), 'Tirar foto'),
    h('button', { class: 'botao secundario', type: 'button', disabled: desativado, onClick: () => arquivo.click() }, 'Escolher arquivo'));
}

// Miniatura de uma foto escolhida e ainda não salva.
export function miniaturaDaPrevia(foto, { aoRemover }) {
  const pdf = foto.mime === 'application/pdf';
  foto.url ??= URL.createObjectURL(foto.blob);
  return h('div', { class: 'miniatura' },
    h('button', { class: 'miniatura-abrir', type: 'button', 'aria-label': pdf ? 'Ver o PDF' : 'Ver a foto', onClick: () => verGrande(foto.url, foto.mime) },
      pdf ? h('span', { class: 'miniatura-pdf' }, 'PDF') : h('img', { src: foto.url, alt: '' })),
    h('button', {
      class: 'miniatura-remover',
      type: 'button',
      'aria-label': pdf ? 'Tirar este PDF' : 'Tirar esta foto',
      onClick: () => {
        URL.revokeObjectURL(foto.url);
        aoRemover();
      },
    }, '×'));
}

// Miniatura de um anexo salvo. A imagem vem do aparelho ou, com sinal, do
// servidor; sem as duas, fica o quadro com o nome.
export function miniaturaDoAnexo(anexo, { esperando = false, aoRemover = null } = {}) {
  const pdf = anexo.mime === 'application/pdf';
  const quadro = h('span', { class: 'miniatura-pdf' }, pdf ? 'PDF' : 'Foto');
  if (!pdf) {
    anexos.endereco(anexo).then((url) => {
      if (url && quadro.isConnected !== false) quadro.replaceWith(h('img', { src: url, alt: '' }));
    }).catch(() => {});
  }
  return h('div', { class: 'miniatura' },
    h('button', { class: 'miniatura-abrir', type: 'button', 'aria-label': pdf ? 'Abrir o PDF do comprovante' : 'Ver a foto do comprovante', onClick: () => abrirAnexo(anexo) }, quadro),
    esperando && h('span', { class: 'miniatura-envio' }, 'Esperando envio'),
    aoRemover && h('button', { class: 'miniatura-remover', type: 'button', 'aria-label': pdf ? 'Tirar este PDF' : 'Tirar esta foto', onClick: aoRemover }, '×'));
}

export async function abrirAnexo(anexo) {
  const url = await anexos.endereco(anexo).catch(() => null);
  if (!url) {
    avisar('Esta foto está só no servidor e o aparelho está sem sinal. Ela abre quando o sinal voltar.', 'erro');
    return;
  }
  verGrande(url, anexo.mime);
}

function verGrande(url, mime) {
  if (mime === 'application/pdf') {
    const a = h('a', { href: url, target: '_blank', rel: 'noopener' });
    document.body.append(a);
    a.click();
    a.remove();
    return;
  }
  dialogo((fechar) => [
    h('img', { class: 'foto-grande', src: url, alt: 'Foto do comprovante' }),
    h('div', { class: 'acoes' }, h('button', { class: 'botao cheio', type: 'button', onClick: () => fechar(null) }, 'Fechar')),
  ]);
}
